const IconNewTab = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2222 18.2222H5.77778V5.77778H12V4H5.77778C4.79111 4 4 4.8 4 5.77778V18.2222C4 19.2 4.79111 20 5.77778 20H18.2222C19.2 20 20 19.2 20 18.2222V12H18.2222V18.2222ZM13.6556 4V5.81269H16.9094L8 14.7221L9.27795 16L18.1873 7.09063V10.3444H20V4H13.6556Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconNewTab;
